export default __webpack_public_path__ + "static/media/10.5b46f601.jpg";